import { JSX, Key } from "react";
import AcceleratorDoc from "../../../models/AcceleratorDoc";
import { ExtractedFieldData } from "../../../models/extraction/ExtractedFieldData";
import { HighlightColours } from "../../../models/HighlightColors";
import { getDisplayName } from "../../../utils/ChromeDebugTools";
import { useSpanHighlights } from "../../hooks/useSpanHighlights";

export { withSpanHighlights };

type WithSpanHighlightProps = {
  acceleratorDoc: AcceleratorDoc;
  extractedData: ExtractedFieldData;
  highlightKey: string;
  index?: number;
  /**
   * True if the RegexDlfEditor is visible. This will change which highlight(s) are sent to the ImageViewer.
   */
  open: boolean;
  /**
   * True if a different DlfEditor is selected.
   */
  otherOpen: boolean;
};

function withSpanHighlights<T>(
  WrappedComponent: React.FunctionComponent<T> | React.ComponentClass<T>,
  key?: Key,
) {
  type WrappedComponentProps = {
    [others: string]: any;
  } & T &
    WithSpanHighlightProps;

  const ComponentWithSpanHighlights = (
    props: WrappedComponentProps,
  ): JSX.Element => {
    useSpanHighlights(
      props.highlightKey,
      HighlightColours.getHighlightColor(props.index ?? 0),
      props.acceleratorDoc,
      props.extractedData,
      // If nothings open, show extraction and reuses for all fields
      // If this open, show extraction and reuse
      // If other open, show dont show reuse or extraction
      props.open || !props.otherOpen,
      props.open || !props.otherOpen,
    );

    return <WrappedComponent {...props} key={key} />;
  };

  ComponentWithSpanHighlights.displayName = getDisplayName<T>(
    WrappedComponent,
    "WithSpanHighlightsComponent",
  );

  return ComponentWithSpanHighlights;
}
